import React from 'react'

import AdvancedNameSection from '../sections/AdvancedNameSection'
import NameSection from '../sections/NameSection'
import DigitalCampaignDatesSection from '../../../ReusableSections/DigitalCampaignDatesSection'
import DigitalRightEditAllocationSection from '../sections/DigitalRightEditAllocationSection'
import RequestAssetsSection from '../../../ReusableSections/RequestAssetsSection'
import ActionsOrCommentsSection from '../../../ReusableSections/ActionsOrCommentsSection'

import useIsAdvancedPartnership from '../../../../../../../features/hooks/useIsAdvancedPartnership'

function DigitalRightEditSections({ formik }) {
  const isAdvancedPartnership = useIsAdvancedPartnership()

  // display simplified amount of sections for advanced partnership digital right edit
  if (isAdvancedPartnership) {
    return (
      <>
        <AdvancedNameSection formik={formik} />
        <DigitalRightEditAllocationSection formik={formik} isAdvancedPartnership />
      </>
    )
  }

  return (
    <>
      <NameSection formik={formik} />
      <DigitalCampaignDatesSection formik={formik} />
      <DigitalRightEditAllocationSection formik={formik} />
      <RequestAssetsSection formik={formik} />
      <ActionsOrCommentsSection formik={formik} />
    </>
  )
}

export default DigitalRightEditSections
